"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IconSelector", {
    enumerable: true,
    get: function() {
        return IconSelector;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _localisationeq1 = require("@equiem/localisation-eq1");
const _IconProvider = require("./IconProvider");
const _contexts = require("../../contexts");
const _hooks = require("../../hooks");
const _AdminDropdownButton = require("../Dropdown/DropdownButton/AdminDropdownButton");
const _Dropdown = /*#__PURE__*/ _interop_require_wildcard(require("../Dropdown"));
const _Form = /*#__PURE__*/ _interop_require_wildcard(require("../Form"));
const _ProgressCircle = require("../ProgressCircle/ProgressCircle");
const _ri = require("react-icons/ri");
const _Icon = require("./Icon");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const IconSelector = (param)=>{
    let { name, selectedIcon, onSelect, onSelectLoading, size = "md", className, onChange } = param;
    const [searchTerm, setSearchTerm] = (0, _react.useState)("");
    const { t } = (0, _localisationeq1.useTranslation)();
    const theme = (0, _contexts.useTheme)();
    const debounceTimeout = 200;
    const debouncedSearchTerm = (0, _hooks.useDebounced)(searchTerm, debounceTimeout);
    const { filteredIcon } = (0, _react.useContext)(_IconProvider.IconContext);
    const icons = (0, _react.useMemo)(()=>{
        return filteredIcon(debouncedSearchTerm);
    }, [
        debouncedSearchTerm,
        filteredIcon
    ]);
    var _t;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_AdminDropdownButton.AdminDropdownButton, {
        className: className,
        variant: "outline",
        dropdownToggleColor: theme.colors.grayscale["60"],
        title: onSelectLoading === true ? /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
            size: "xs"
        }) : selectedIcon != null ? /*#__PURE__*/ _react.default.createElement(_Icon.Icon, {
            name: selectedIcon,
            size: "sm"
        }) : /*#__PURE__*/ _react.default.createElement(_ri.RiQuestionLine, {
            size: "18px",
            color: theme.colors.grayscale["60"]
        }),
        size: size,
        disabled: onSelectLoading === true,
        fixedHeader: /*#__PURE__*/ _react.default.createElement("div", {
            className: _style.default.dynamic([
                [
                    "9193300e6a4d3628",
                    [
                        theme.spacers.s2
                    ]
                ]
            ]) + " " + "px-3 pb-2"
        }, /*#__PURE__*/ _react.default.createElement(_Form.InputGroup.Group, null, /*#__PURE__*/ _react.default.createElement(_Form.InputGroup.Prefix, null, /*#__PURE__*/ _react.default.createElement(_ri.RiSearchLine, {
            size: 16
        })), /*#__PURE__*/ _react.default.createElement(_Form.Input, {
            type: "text",
            placeholder: (_t = t("common.search")) !== null && _t !== void 0 ? _t : "",
            className: "search",
            value: searchTerm,
            onChange: (e)=>setSearchTerm(e.target.value),
            maxLength: 20
        }), searchTerm !== "" && /*#__PURE__*/ _react.default.createElement(_Form.InputGroup.Suffix, null, /*#__PURE__*/ _react.default.createElement(_ri.RiCloseCircleLine, {
            onClick: ()=>setSearchTerm("")
        }))))
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "9193300e6a4d3628",
                [
                    theme.spacers.s2
                ]
            ]
        ]) + " " + "icon-container px-3"
    }, icons.map((icon)=>/*#__PURE__*/ _react.default.createElement(_Dropdown.Item, {
            showTick: false,
            selected: selectedIcon === icon.name,
            key: icon.name,
            className: "p-2 m-0 d-flex align-items-center",
            onClick: ()=>{
                onSelect(icon.name);
                onChange === null || onChange === void 0 ? void 0 : onChange({
                    target: {
                        name: name,
                        value: icon.name
                    }
                });
            }
        }, /*#__PURE__*/ _react.default.createElement(_Icon.Icon, {
            name: icon.name,
            humanName: icon.human,
            fontSize: "20px",
            className: "cursor-pinter",
            color: theme.colors.grayscale["60"]
        }))), icons.length === 0 && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "9193300e6a4d3628",
                [
                    theme.spacers.s2
                ]
            ]
        ]) + " " + "p-3 empty-result"
    }, t("common.emptySearch", {
        searchTerm: debouncedSearchTerm
    })))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "9193300e6a4d3628",
        dynamic: [
            theme.spacers.s2
        ]
    }, ".icon-container.__jsx-style-dynamic-selector{display:grid;grid-template-columns:repeat(8,29px);gap:".concat(theme.spacers.s2, "}.empty-result.__jsx-style-dynamic-selector{min-width:280px}")));
};

//# sourceMappingURL=IconSelector.js.map